import { render, staticRenderFns } from "./UpdatePasswordView.vue?vue&type=template&id=709c0018&scoped=true&"
import script from "./UpdatePasswordView.vue?vue&type=script&lang=js&"
export * from "./UpdatePasswordView.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePasswordView.vue?vue&type=style&index=0&id=709c0018&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709c0018",
  null
  
)

export default component.exports